export default {
  diligence: 'Start',
  searches: 'Searches',
  ofac: 'OFAC',
  documents: 'Documents',
  review: 'Review'
};
